import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_bqcgv7uqrr: FaireBrandEntity = {
  token: "b_bqcgv7uqrr",
  type: "brand",
  name: "Healing Herbals",
  avatarUrl:
    "https://cdn.faire.com/fastly/f2b2765bf06bf4b8a339bf6c751d264abf4b7fbe66078ab0bd5ca9fdca2d9ae3.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/d835b8c24673137e891131b58b71c7c12199e16387c55b172867a1b31755cb47.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/f2b2765bf06bf4b8a339bf6c751d264abf4b7fbe66078ab0bd5ca9fdca2d9ae3.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/d835b8c24673137e891131b58b71c7c12199e16387c55b172867a1b31755cb47.jpeg",
  location: "East Patchogue, NY, USA",
  minimumOrderDollars: 139,
  rating: 5,
  reviewCount: 4,
  isTopShop: true,
  isInsider: true,
  description:
    "We are a small team of herbal enthusiasts based in Long Island, New York, dedicated to educating and sharing the beauty of herbal medicine. Our mission is to introduce others to the natural benefits of botanicals, with a special focus on Sceletium tortuosum (Kanna) tea, plant extracts, kava, and a variety of other wellness-focused products.\n\nWe believe in the power of nature to support mental clarity, relaxation, and overall well-being. Every product we offer is carefully sourced and crafted with quality in mind, ensuring our customers experience the best that herbal medicine has to offer.\n\nBeyond our products, we strive to create a community that fosters curiosity and understanding about the many plants and traditions that have supported human wellness for centuries. Whether you're looking to explore new herbal remedies, deepen your connection with nature, or simply find a moment of calm in your day, we’re here to guide and support you.\n\nThank you for being part of our journey toward holistic wellness. Let’s explore the beauty of the plant world together!\n\n",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:20.473Z",
    importedBy: "entity-db-cli",
  },
};
